export default __webpack_public_path__ + "static/media/10l-act.e3610480.svg";